document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".curreny__selector-options")
    .forEach((selector) => {
      const button = selector.querySelector(".country-button");
      const countryList = selector.querySelector(".country-list");
      const countryInput = selector.querySelector(".selected-country-code");
      const form = selector.querySelector(".country-selector-form");

      button.addEventListener("click", function () {
        if (countryList.style.display === "block") {
          countryList.style.display = "none";
          button.classList.remove("active");
        } else {
          countryList.style.display = "block";
          button.classList.add("active");
        }
      });

      selector.querySelectorAll(".country-list li").forEach((item) => {
        item.addEventListener("click", function () {
          const selectedCountry = this.dataset.value;
          const selectedCurrency = this.dataset.currency;
          const selectedSymbol = this.dataset.symbol;
          const flagSrc = this.querySelector(".country-flag").src;

          button.innerHTML = `
          <img class="country-flag" src="${flagSrc}" alt="Flag">
          <span class="country-currency">
            ${selectedCountry}(${selectedCurrency} ${selectedSymbol})
          </span>
          <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.4997 7.22497C6.36636 7.22497 6.24136 7.20397 6.1247 7.16197C6.00803 7.12064 5.8997 7.04997 5.7997 6.94997L1.1747 2.32497C0.991363 2.14164 0.90403 1.9123 0.912696 1.63697C0.920696 1.3623 1.01636 1.1333 1.1997 0.94997C1.38303 0.766637 1.61636 0.67497 1.8997 0.67497C2.18303 0.67497 2.41636 0.766637 2.5997 0.94997L6.4997 4.84997L10.4247 0.92497C10.608 0.741636 10.8374 0.65397 11.1127 0.66197C11.3874 0.670637 11.6164 0.766637 11.7997 0.94997C11.983 1.1333 12.0747 1.36664 12.0747 1.64997C12.0747 1.9333 11.983 2.16664 11.7997 2.34997L7.1997 6.94997C7.0997 7.04997 6.99136 7.12064 6.8747 7.16197C6.75803 7.20397 6.63303 7.22497 6.4997 7.22497Z" fill="currentColor"/>
          </svg>
        `;

          countryInput.value = selectedCountry;
          countryList.style.display = "none";
          button.classList.remove("active");
          form.submit();
        });
      });

      document.addEventListener("click", function (event) {
        if (!selector.contains(event.target)) {
          countryList.style.display = "none";
          button.classList.remove("active");
        }
      });
    });
});
